module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scene"
  }, [_c('div', {
    staticClass: "eucore-editor",
    attrs: {
      "id": "eucore-scene-editor"
    }
  }, [_c('div', {
    staticClass: "sel-layer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selVisible && !_vm.isMultiSel),
      expression: "selVisible && !isMultiSel"
    }],
    staticClass: "sel-box",
    style: (_vm.selBoxStyle),
    on: {
      "pointerdown": _vm.onSelPointerDown
    }
  }, [(!_vm.isOriginSel) ? [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "sel-btn flip",
    attrs: {
      "data-action": "flip",
      "title": "翻转"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "sel-btn reset",
    attrs: {
      "data-action": "reset",
      "title": "重置"
    }
  }), _vm._v(" "), (_vm.selIsFrames) ? _c('button', {
    staticClass: "sel-btn frames",
    attrs: {
      "data-action": "frames",
      "title": "序列帧设置"
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "sel-btn delete",
    attrs: {
      "data-action": "delete",
      "title": "删除"
    }
  })] : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.multiFrames), function(f) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selVisible && _vm.isMultiSel),
        expression: "selVisible && isMultiSel"
      }],
      key: 'm' + f.alias,
      staticClass: "sel-box multi",
      style: (_vm.multiFrameStyle(f)),
      on: {
        "pointerdown": _vm.onSelPointerDown
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.peb.show),
      expression: "peb.show"
    }],
    staticClass: "peb"
  }, [_c('svg', {
    staticClass: "peb-svg",
    attrs: {
      "viewBox": _vm.pebViewBox,
      "preserveAspectRatio": "none"
    }
  }, [_c('polygon', {
    staticClass: "peb-border",
    attrs: {
      "points": _vm.pebQuadPoints
    }
  }), _vm._v(" "), (_vm.pebShowHandle('rotate')) ? _c('line', {
    staticClass: "peb-guide",
    attrs: {
      "x1": _vm.peb.d[0],
      "y1": _vm.peb.d[1],
      "x2": _vm.pebRotatePos[0],
      "y2": _vm.pebRotatePos[1]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pebShowHandle('move')) ? _c('line', {
    staticClass: "peb-guide",
    attrs: {
      "x1": _vm.pebRightMid[0],
      "y1": _vm.pebRightMid[1],
      "x2": _vm.pebMovePos[0],
      "y2": _vm.pebMovePos[1]
    }
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.pebCornerPos), function(p, k) {
    return (_vm.pebShowHandle(k)) ? _c('div', {
      key: 'c' + k,
      staticClass: "peb-h corner",
      style: ({
        left: p[0] + 'px',
        top: p[1] + 'px'
      }),
      attrs: {
        "data-handle": k
      },
      on: {
        "pointerdown": _vm.onPebPointerDown
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.pebEdgePos), function(p, k) {
    return (_vm.pebShowHandle(k)) ? _c('div', {
      key: 'e' + k,
      staticClass: "peb-h edge",
      style: ({
        left: p[0] + 'px',
        top: p[1] + 'px'
      }),
      attrs: {
        "data-handle": k
      },
      on: {
        "pointerdown": _vm.onPebPointerDown
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.pebShowHandle('rotate')) ? _c('div', {
    staticClass: "peb-h rotate",
    style: ({
      left: _vm.pebRotatePos[0] + 'px',
      top: _vm.pebRotatePos[1] + 'px'
    }),
    attrs: {
      "title": "旋转",
      "data-handle": "rotate"
    },
    on: {
      "pointerdown": _vm.onPebPointerDown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pebShowHandle('move')) ? _c('div', {
    staticClass: "peb-h move",
    style: ({
      left: _vm.pebMovePos[0] + 'px',
      top: _vm.pebMovePos[1] + 'px'
    }),
    attrs: {
      "title": "移动",
      "data-handle": "move"
    },
    on: {
      "pointerdown": _vm.onPebPointerDown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.peb.showCenter && _vm.pebShowHandle('center')) ? _c('div', {
    staticClass: "peb-h center",
    style: ({
      left: _vm.peb.center[0] + 'px',
      top: _vm.peb.center[1] + 'px'
    }),
    attrs: {
      "title": "中心点",
      "data-handle": "center"
    },
    on: {
      "pointerdown": _vm.onPebPointerDown
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.peb.slots), function(s) {
    return _c('div', {
      key: 's' + s.id,
      staticClass: "peb-h slot",
      class: {
        keyway: s.type === 1
      },
      style: ({
        left: s.x + 'px',
        top: s.y + 'px'
      }),
      attrs: {
        "title": s.type === 1 ? '插位' : '槽位',
        "data-handle": "slot",
        "data-slot": s.id
      },
      on: {
        "pointerdown": _vm.onPebPointerDown
      }
    })
  }), _vm._v(" "), (_vm.pebShowCtrl()) ? _c('div', {
    staticClass: "peb-ctrl",
    style: ({
      left: _vm.pebCtrlPos[0] + 'px',
      top: _vm.pebCtrlPos[1] + 'px'
    })
  }, [(_vm.pebShowCtrl('up')) ? _c('button', {
    staticClass: "peb-btn peb-up",
    attrs: {
      "title": "上移层",
      "data-handle": "up"
    },
    on: {
      "pointerdown": _vm.onPebPointerDown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pebShowCtrl('down')) ? _c('button', {
    staticClass: "peb-btn peb-down",
    attrs: {
      "title": "下移层",
      "data-handle": "down"
    },
    on: {
      "pointerdown": _vm.onPebPointerDown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pebShowCtrl('hold') && _vm.peb.type === 'PART') ? _c('button', {
    staticClass: "peb-btn peb-hold",
    attrs: {
      "title": "绑定道具",
      "data-handle": "hold"
    },
    on: {
      "pointerdown": _vm.onPebPointerDown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pebShowCtrl('unhold') && _vm.peb.type === 'HOLDBUNDLE' && _vm.peb.editType !== 'EDITTYPE_PROPINIT') ? _c('button', {
    staticClass: "peb-btn peb-unhold",
    attrs: {
      "title": "解绑道具",
      "data-handle": "unhold"
    },
    on: {
      "pointerdown": _vm.onPebPointerDown
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pebShowCtrl('reset')) ? _c('button', {
    staticClass: "peb-btn peb-reset",
    attrs: {
      "title": "重置",
      "data-handle": "reset"
    },
    on: {
      "pointerdown": _vm.onPebPointerDown
    }
  }) : _vm._e()]) : _vm._e()], 2)], 2)]), _vm._v(" "), _c('object', {
    staticStyle: {
      "display": "none",
      "width": "0",
      "height": "0"
    },
    attrs: {
      "id": "SCENE-SWF"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sel-corner nw"
  }, [_c('div', {
    staticClass: "sel-handle",
    attrs: {
      "data-action": "scale"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sel-rot",
    attrs: {
      "data-action": "rotate",
      "title": "旋转"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sel-corner ne"
  }, [_c('div', {
    staticClass: "sel-handle",
    attrs: {
      "data-action": "scale"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sel-rot",
    attrs: {
      "data-action": "rotate",
      "title": "旋转"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sel-corner se"
  }, [_c('div', {
    staticClass: "sel-handle",
    attrs: {
      "data-action": "scale"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sel-rot",
    attrs: {
      "data-action": "rotate",
      "title": "旋转"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sel-corner sw"
  }, [_c('div', {
    staticClass: "sel-handle",
    attrs: {
      "data-action": "scale"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sel-rot",
    attrs: {
      "data-action": "rotate",
      "title": "旋转"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f44e8c12","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scene/Scene.vue
// module id = 405
// module chunks = 0